import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import UserLink from '../../../User/Link/UserLink';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import DeviationFlags from '../../buttons/DeviationFlags';
import ExpandButton from '../../buttons/ExpandButton';
import { getDeviationTitle } from '../../../DeviationViews/_helpers';
import { ActionBarProps as Props } from '../../types';

import s from './ExpandActionBar.scss';

const ExpandActionBar: React.FC<Props> = ({
  deviation,
  deviation: { author },
  isOwner,
  className,
}) => {
  const { hasFlag } = useDeviationAttributes(deviation, isOwner);
  const deviationTitle = getDeviationTitle(deviation);
  const showTitle = !!deviationTitle;

  return (
    <Flex
      className={classnames(s['root'], hasFlag && s['with-badge'], className)}
      justifyContent="center"
      alignItems="center"
    >
      <div className={s['badge']}>
        {hasFlag && <DeviationFlags deviation={deviation} alwaysExpanded />}
      </div>
      <div className={s['info']}>
        {showTitle && <div className={s['title']}>{deviationTitle}</div>}
        {author && (
          <div className={s['author']}>
            {/* prettier-ignore */}
            <Trans i18nKey="common.created.byLink">
              <span className={s['by']}>By</span> <UserLink user={author} />
            </Trans>
          </div>
        )}
      </div>
      <Flex alignItems="center" className={s['right-block']}>
        <div className={s['view-switcher']}>
          <ExpandButton deviation={deviation} />
        </div>
      </Flex>
    </Flex>
  );
};
ExpandActionBar.displayName = 'ExpandActionBar';

export default ExpandActionBar;
